import React from 'react'

import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { FormField } from '@/components/forms/FormField'
import { TextInput } from '@/components/forms/TextInput'

import { getFieldErrorMessage } from './formik.helpers'

export const NumberField = ({
  label,
  errorMessage,
  field: { name, value, ...fieldProps },
  form: { touched, errors },
  ...props
}) => {
  const error = getFieldErrorMessage({ errorMessage, errors, touched, name })

  return (
    <FormField error={Boolean(error)}>
      {label && <label htmlFor={name}>{label}</label>}
      <TextInput
        data-testid={`numberField-${name}`}
        type="number"
        id={name}
        name={name}
        value={value ?? ''}
        error={Boolean(error)}
        onKeyDown={(event) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
        {...fieldProps}
        {...props}
      />
      {error && <ErrorMessage content={error} />}
    </FormField>
  )
}
